import { call } from 'redux-saga/effects';
import { newInstance } from 'localization';
import { generatePath } from 'react-router-dom';
import { filter, length, pipe } from 'ramda';

import book from 'routes/book';

import { INTEGRATION_SERVICES } from './constants';

const PRICE_BY_PERSON = 350;
const INFANT_AGE = 1;

const getServicePrice = peopleCount => peopleCount * PRICE_BY_PERSON;

const getChildrenCount = children => pipe(
  filter(age => age > INFANT_AGE),
  length,
)(children);

export function* getIntegrationServicesSaga({ payload: { callbacks, offer: { people } } }) {
  const { onSuccess, onFail } = callbacks;

  const { adults, children } = people;

  try {
    yield call(
      onSuccess,
      [
        {
          id: INTEGRATION_SERVICES.NON_ARRIVAL_INSURANCE,
          name: newInstance.t('TS:INTEGRATION_SERVICES:NON_ARRIVAL_INSURANCE_LABEL'),
          detailsLink: generatePath(book.news.children.single, { id: 265 }),
          price: getServicePrice(
            adults + getChildrenCount(children)
          )
        },
      ]
    );
  } catch (error) {
    onFail && onFail(error);
  }
}
